import React, { useEffect, useState } from 'react';
import { Link } from 'react-scroll';
import { siteData } from '../mock';

const navLinks = [
  { to: 'about', label: 'About' },
  { to: 'portfolio', label: 'Work' },
  { to: 'blog', label: 'Notes' },
  { to: 'contact', label: 'Contact' }
];

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed left-0 right-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/85 backdrop-blur-xl border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-5 lg:px-8">
        <Link to="hero" smooth duration={500} className="cursor-pointer text-lg font-semibold tracking-[0.2em] text-white hover:text-pink-accent">
          {siteData.monogram}
        </Link>

        <div className="hidden items-center gap-6 md:flex lg:gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              smooth
              duration={500}
              offset={-72}
              className="nav-link cursor-pointer text-sm uppercase tracking-[0.18em] text-white/72"
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
